const FALLBACK_SERVER_URL = "https://rentdigicare.ca/api";
const FALLBACK_CHAT_URL = "wss://rentdigicare.ca/api";

export const SERVER_URL = (process.env.REACT_APP_SERVER_URL || FALLBACK_SERVER_URL).replace(/\/+$/, "");
export const CHAT_URL = process.env.REACT_APP_CHAT_URL || FALLBACK_CHAT_URL;

export const IS_PRODUCTION_BUILD = process.env.NODE_ENV === "production";
export const IS_LIVE_API = /rentdigicare\.(com|ca)/i.test(SERVER_URL);

if (typeof window !== "undefined" && !window.__rdc_api_banner_shown__) {
  window.__rdc_api_banner_shown__ = true;
  const mode = IS_PRODUCTION_BUILD ? "PRODUCTION BUILD" : "DEV";
  const tag = IS_LIVE_API ? "LIVE API" : "LOCAL API";
  const style = IS_LIVE_API
    ? "background:#b91c1c;color:#fff;padding:2px 8px;border-radius:3px;font-weight:bold"
    : "background:#16a34a;color:#fff;padding:2px 8px;border-radius:3px;font-weight:bold";
  console.info(`%c[${mode}] ${tag}%c  →  ${SERVER_URL}`, style, "color:inherit");
}
